import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { Tbody, Td, Tr } from './TBody.styles';

export function TBody({ items }) {
  if (!items?.length) return null;

  return (
    <Tbody>
      {items.map(({ label, value, hint }) => {
        if (label && value) {
          return (
            <Tr key={label}>
              <Td>
                {label}

                {hint && 'hint'}
              </Td>

              <Td>{value}</Td>
            </Tr>
          );
        }

        return null;
      })}
    </Tbody>
  );
}

TBody.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      hint: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    })
  ).isRequired,
};

export default memo(TBody);
